import { useEffect } from 'react';

import { useUnsavedChangesContext } from '@providers/unsavedChangesProvider';

interface Props {
  detectedChanges: boolean;
  message?: string;
}

const useUnsavedChanges = ({ detectedChanges, message }: Props) => {
  const { setHasUnsavedChanges } = useUnsavedChangesContext();

  useEffect(() => {
    setHasUnsavedChanges(detectedChanges, message);
  }, [detectedChanges, message, setHasUnsavedChanges]);

  return null;
};

export default useUnsavedChanges;
